import type { CheckoutStore } from '@stores/checkout/interfaces'
import type { Order } from '@brighterly/lib-core-types/orders/interfaces'

export const oneTimePaymentGetters = {
  getOrderTotal: (state: CheckoutStore): Order['total'] => state.order?.total || 0,
}
